import axios from "axios";
import {
  createUserWithEmailAndPassword,
  deleteUser,
  getAuth,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";

import * as BOOKED_RESERVATIONS from "../advertissements/advertissements.api.routes";
import {
  AUTH_ASK_BUDGET,
  AUTH_CANCEL_MEETING,
  AUTH_CHECK_CANCEL,
  AUTH_CHECK_SCHEDULE_STUDENT,
  AUTH_CHECK_USERS_OTP,
  AUTH_DISSOCIATE_ACCOUNT,
  AUTH_DISSOCIATE_STUDENT,
  AUTH_GET_PARENT_ORGANISM_PAYMENTS,
  AUTH_GET_PARENT_ORGANISM_STUDENTS,
  AUTH_GET_STUDENT,
  AUTH_GET_STUDENT_HISTORY_DATA,
  AUTH_GET_STUDENT_PAYMENTS,
  AUTH_GET_STUDENT_STATS,
  AUTH_GET_STUDENTS_CREDENTIALS,
  AUTH_GET_SUGGESTED_TEACHER,
  AUTH_GET_TEACHER_STUDENT_HISTORY_DATA,
  AUTH_GET_TEACHER_STUDENTS,
  AUTH_GET_USER_EMAIL,
  AUTH_INVITE_STUDENT,
  AUTH_NOT_SUGGEST_TEACHER,
  AUTH_PARENT_ORGANISATION,
  AUTH_RATE_STUDENTS,
  AUTH_RATE_TEACHER,
  AUTH_REGISTER_STUDENT,
  AUTH_REQUEST_USERS_OTP,
  AUTH_SCHEDULE_MEETING,
  AUTH_SEND_ACCOUNT_TOP_UP,
  AUTH_SEND_BUDGET,
  AUTH_SEND_EQUAL_TOP_UP,
  AUTH_SEND_SCHEDULE_MESSAGE,
  AUTH_STUDENT,
  AUTH_SUGGEST_TEACHER,
  AUTH_TEACHER,
  AUTH_TEACHER_DATA,
  AUTH_USER,
  AUTH_USER_OTP,
  AUTH_USERS,
  RESSOURCES_BO
} from "./auth.api.routes";
import { CreateUserDto } from "./dto/create-user.dto";

import { getToken } from "api";
import { UserRoles } from "common/enums";
import { ApiResponse } from "common/interfaces";
import { FirebaseUser } from "config/firebase.config";
import { API_RESSOURCES } from "../teacher/teacher.routes";
import { loginUserDto, registerUserDto } from "./dto/login-user.dto";

export const logout = async (): Promise<boolean> => {
  try {
    const auth = getAuth();
    await signOut(auth);
    return true;
  } catch (error: any) {
    return false;
  }
};

/* export const registerStudent = async (
  user: CreateUserDto
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_STUDENT}`, user, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
}; */

export const registerStudent = async (
  user: CreateUserDto
): Promise<ApiResponse | undefined> => {
  const MAX_RETRIES = 5;

  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");

    let attempt = 0;

    while (attempt < MAX_RETRIES) {
      try {
        const response = await axios.post(`${AUTH_STUDENT}`, user, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        return response.data;
      } catch (error: any) {
        attempt++;

        const status = error?.response?.status;
        const retryableStatusCodes = [429, 500, 502, 503, 504];

        if (attempt >= MAX_RETRIES || (status && !retryableStatusCodes.includes(status))) {
          throw error;
        }

        const delay = Math.pow(2, attempt) * 200; // 200ms, 400ms, 800ms...
        console.warn(`Retrying registerStudent (${attempt}/${MAX_RETRIES}) in ${delay}ms...`);
        await sleep(delay);
      }
    }
  } catch (error: any) {
    throw error;
  }
};

/* export const registerTeacher = async (
  user: CreateUserDto
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    // if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_TEACHER}`, user, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    const auth = getAuth();
    const currentUser: any = auth.currentUser;
    // if the  user is new delete the user
    const isNew = currentUser?.metadata?.createdAt === currentUser?.metadata?.lastLoginAt;
    if (isNew && currentUser) {
      await deleteUser(currentUser);
    } else {
      await logout();
    }

    throw error;
  }
}; */

export const registerTeacher = async (
  user: CreateUserDto
): Promise<ApiResponse | undefined> => {
  const MAX_RETRIES = 5;

  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");

    let attempt = 0;

    while (attempt < MAX_RETRIES) {
      try {
        const response = await axios.post(`${AUTH_TEACHER}`, user, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        return response.data;
      } catch (error: any) {
        attempt++;

        const status = error?.response?.status;
        const retryableStatusCodes = [429, 500, 502, 503, 504];

        if (attempt >= MAX_RETRIES || (status && !retryableStatusCodes.includes(status))) {
          throw error;
        }

        const delay = Math.pow(2, attempt) * 200;
        console.warn(`Retrying registerTeacher (${attempt}/${MAX_RETRIES}) in ${delay}ms...`);
        await sleep(delay);
      }
    }
  } catch (error: any) {
    const auth = getAuth();
    const currentUser: any = auth.currentUser;
    const isNew = currentUser?.metadata?.createdAt === currentUser?.metadata?.lastLoginAt;

    if (isNew && currentUser) {
      await deleteUser(currentUser);
    } else {
      await logout();
    }

    throw error;
  }
};


/* export const registerParentOrganisation = async (
  values: CreateUserDto,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    const response = await axios.post(`${AUTH_PARENT_ORGANISATION}`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    const auth = getAuth();
    const currentUser: any = auth.currentUser;
    const isNew = currentUser?.metadata?.createdAt === currentUser?.metadata?.lastLoginAt;
    if (isNew && currentUser) {
      await deleteUser(currentUser);
    } else {
      await logout();
    }
    throw error;
  }
}; */

export const registerParentOrganisation = async (
  values: CreateUserDto,
): Promise<ApiResponse | undefined> => {
  const MAX_RETRIES = 5;

  const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  try {
    const token = await getToken();
    let attempt = 0;

    while (attempt < MAX_RETRIES) {
      try {
        const response = await axios.post(`${AUTH_PARENT_ORGANISATION}`, values, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        return response.data;
      } catch (error: any) {
        attempt++;

        // Only retry for network errors or certain status codes
        const retryableStatusCodes = [429, 500, 502, 503, 504];
        const status = error?.response?.status;

        if (attempt >= MAX_RETRIES || (status && !retryableStatusCodes.includes(status))) {
          throw error;
        }

        const delay = Math.pow(2, attempt) * 200; // Exponential backoff: 200ms, 400ms, 800ms, etc.
        console.warn(`Retrying (${attempt}/${MAX_RETRIES}) in ${delay}ms...`);
        await sleep(delay);
      }
    }
  } catch (error: any) {
    const auth = getAuth();
    const currentUser: any = auth.currentUser;
    const isNew = currentUser?.metadata?.createdAt === currentUser?.metadata?.lastLoginAt;

    if (isNew && currentUser) {
      await deleteUser(currentUser);
    } else {
      await logout();
    }

    throw error;
  }
};

export const reauthenticateParentOrganisation = async (
  email: string,
  password: string,
): Promise<FirebaseUser | undefined> => {
  try {
    const user = { email: email, password: password };
    const response = await logInFirebaseWithEmailAndPassword(user);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const registerSponsoredStudentWithEmailPassword = async (
  values: any,
): Promise<ApiResponse | undefined> => {
  try {
    const response = await registerInFirebaseWithEmailAndPassword(values);
    if (response) {
      const studentData = {
        uid: response.uid,
        firstname: values.firstname,
        lastname: values.lastname,
        email: values.email,
        pseudo: values.pseudo,
        levelId: values.levelId,
        profile: "/assets/avatars/student.svg",
        avatar: "",
        roles: [UserRoles.STUDENT],
        pays: values.pays,
        phone: "0000000000",
        education: values.etablissement,
        etablissement: values.etablissement,
        educSystem: values.educSystem,
        accountManaged: values.accountManaged,
        organisationName: values.organisationName,
        password: values.password,
        fuseauHorraire: values.fuseauHorraire,
      };
      const result = await registerSponsoredStudent(studentData);
      return result;
    }
  } catch (error: any) {
    throw error;
  }
};

export const registerSponsoredStudent = async (
  values: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_STUDENT}`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

/* export const registerSponsoredStudent = async (
  values: any,
): Promise<ApiResponse | undefined> => {
  const MAX_RETRIES = 5;

  const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");

    let attempt = 0;

    while (attempt < MAX_RETRIES) {
      try {
        const response = await axios.post(`${AUTH_STUDENT}`, values, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        return response.data;
      } catch (error: any) {
        attempt++;

        const retryableStatusCodes = [429, 500, 502, 503, 504];
        const status = error?.response?.status;

        if (attempt >= MAX_RETRIES || (status && !retryableStatusCodes.includes(status))) {
          throw error;
        }

        const delay = Math.pow(2, attempt) * 200; // 200ms, 400ms, 800ms...
        console.warn(`Retrying registerSponsoredStudent (${attempt}/${MAX_RETRIES}) in ${delay}ms...`);
        await sleep(delay);
      }
    }
  } catch (error: any) {
    throw error;
  }
}; */

export const registerInFirebaseWithEmailAndPassword = async (
  infos: registerUserDto
): Promise<FirebaseUser | undefined> => {
  try {
    const { email, password } = infos;
    const auth = getAuth();
    const userCredential: any = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;
    // await userCredential?.user?.sendEmailVerification();
    return user;
  } catch (error) {
    throw error;
  }
};

export const registerInFirebaseWithGoogle = async (): Promise<
  FirebaseUser | undefined
> => {
  try {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    provider.addScope("profile");
    provider.addScope("email");
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    return user;
  } catch (error: any) {
    await logout();
    throw error;
  }
};

export const logInFirebaseWithEmailAndPassword = async (
  infos: loginUserDto
): Promise<FirebaseUser | undefined> => {
  try {
    const auth = getAuth();
    const { email, password } = infos;
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;
    localStorage.setItem('userPasscode', password);
    return user;
  } catch (error: any) {
    throw error;
  }
};

/* export const getUserByUid = async (
  uid: string
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${AUTH_USER}/uid/${uid}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
}; */

export const getUserByUid = async (
  uid: string
): Promise<ApiResponse | undefined> => {
  const MAX_RETRIES = 5;

  const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");

    let attempt = 0;

    while (attempt < MAX_RETRIES) {
      try {
        const response = await axios.get(`${AUTH_USER}/uid/${uid}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        });
        return response.data;
      } catch (error: any) {
        attempt++;

        const retryableStatusCodes = [429, 500, 502, 503, 504];
        const status = error?.response?.status;

        if (attempt >= MAX_RETRIES || (status && !retryableStatusCodes.includes(status))) {
          throw error;
        }

        const delay = Math.pow(2, attempt) * 200; // 200ms, 400ms, 800ms...
        console.warn(`Retrying getUserByUid (${attempt}/${MAX_RETRIES}) in ${delay}ms...`);
        await sleep(delay);
      }
    }
  } catch (error: any) {
    throw error;
  }
};

export const loginUser = {};

export const updateTeacher = async (
  id: string,
  user: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.patch(`${AUTH_TEACHER}/${id}`, user, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const checkOTP = async (
  email: string,
  otp: string
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_USER_OTP}`, { email, otp }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const requestOTP = async (
  email: string,
  user: string,
): Promise<ApiResponse | undefined> => {
  try {
    const response = await axios.post(`${AUTH_REQUEST_USERS_OTP}`, { email, user }, {});
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const validateOTP = async (
  email: string,
  code: string
): Promise<ApiResponse | undefined> => {
  try {
    const response = await axios.post(`${AUTH_CHECK_USERS_OTP}`, { email, code }, {});
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const requestPhoneOTP = async (
  phone: string,
): Promise<ApiResponse | undefined> => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/phone/request-otp`, { phone }, {});
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const verifyPhoneOTP = async (
  phone: string,
  code: string,
): Promise<ApiResponse | undefined> => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/phone/validate-otp`, { phone, code }, {});
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const resetPassword = async (
  email: string,
  code: string,
  newPassword: string,
  confirmPassword: string,
): Promise<ApiResponse | undefined> => {
  try {
    const response = await axios.post(`${AUTH_USERS}/reset-password`, { email, code, newPassword, confirmPassword });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getTeacherData = async (
  userId: string,
  teacherId: string
): Promise<ApiResponse | undefined> => {
  try {
    //const token = await getToken();
    ///if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_TEACHER_DATA}`, { userId, teacherId }, {
      headers: {
        ///Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateStudent = async (
  id: string,
  user: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.patch(`${AUTH_STUDENT}/${id}`, user, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const updateParentOrganisme = async (
  id: string,
  user: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.patch(`${AUTH_PARENT_ORGANISATION}/${id}`, user, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getBookedReservations = async (
  id: string
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(
      `${BOOKED_RESERVATIONS.getBookedReservations(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getReservationsHistory = async (
  id: string
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(
      `${BOOKED_RESERVATIONS.getReservationsHistory(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getWalletSuccessReservationsHistory = async (
  id: string
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(
      `${BOOKED_RESERVATIONS.getWalletSuccessReservationsHistory(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getSuccessCollectifCourses = async (
  teacherID: string,
  classeId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${API_RESSOURCES}/advertisements/collective/wallet/sessions?teacherId=${teacherID}&classeId=${classeId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getWalletBookedReservationsHistory = async (
  id: string
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(
      `${BOOKED_RESERVATIONS.getWalletBookedReservationsHistory(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getOrganismReservationsHistory = async (
  id: string
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(
      `${BOOKED_RESERVATIONS.getOrganismReservationsHistory(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const createRetrait = async (
  demande: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${RESSOURCES_BO}`, demande, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const createCollectifRetrait = async (
  data: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${API_RESSOURCES}/retraits/collective`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getPaymentDetails = async (
  teacherId: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${API_RESSOURCES}/advertisements/teacher/totalEarning/${teacherId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getWithdraws = async (
  teacherId: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${API_RESSOURCES}/retraits/teacher/history/${teacherId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getPenalties = async (
  teacherId: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${API_RESSOURCES}/cancellations/unprocessed/${teacherId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getCollectifWalletSummary = async (
  teacherId: any,
  classeId: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${API_RESSOURCES}/advertisements/collective/wallet/summary?teacherId=${teacherId}&classeId=${classeId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const createFreeCouponCode = async (
  teacherId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${API_RESSOURCES}/coupons/teacher/freelink/${teacherId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const checkCouponCode = async (
  couponCode: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${API_RESSOURCES}/coupons/teacher/${couponCode}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getGamification = async (
  userType: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`https://api-ressources.monamialbert.com/api/v1/gamification/rules?userType=${userType}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const inviteStudents = async (
  id: string,
  listInvite: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_INVITE_STUDENT}`, { id, listInvite }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const registerStudents = async (
  id: string,
  listInvite: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_REGISTER_STUDENT}`, { id, listInvite }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const sponsorStudents = async (
  students: any,
  managerId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/affiliations/send-request`, { students, managerId }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getSponsoredStudents = async (
  search: string,
  level: string,
  id: string,
  page: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${AUTH_GET_STUDENT}/subStudents?search=${search}&level=${level}&id=${id}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getStudentStats = async (
  id: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${AUTH_GET_STUDENT_STATS}/more?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getStudentPaiementHistory = async (
  id: string,
  page: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${AUTH_GET_STUDENT_PAYMENTS}/one?id=${id}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

/* export const getParentOrganismTopUpHistory = async (
  id: string,
  page: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${AUTH_GET_PARENT_ORGANISM_TOP_UP}/historique?id=${id}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
}; */

export const getParentOrganismTopUpHistory = async (
  userId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${process.env.REACT_APP_API_URL_USER_DATA}/payments?user=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getParentOrganismStudentsTopUpHistory = async (
  userId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${API_RESSOURCES}/users/backoffice/admin/utilisateurs/wallet/transactions?user=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getParentOrganismPaiementHistory = async (
  id: string,
  page: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${AUTH_GET_PARENT_ORGANISM_PAYMENTS}/all?id=${id}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const suggestTeacher = async (
  id: string,
  idProf: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_SUGGEST_TEACHER}`, { id, idProf }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const cancelSuggestTeacher = async (
  id: string,
  idProf: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_NOT_SUGGEST_TEACHER}`, { id, idProf }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const askBudget = async (
  id: string,
  idProf: string,
  idStud: string,
  montant: any,
  message: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_ASK_BUDGET}`, { id, idProf, idStud, montant, message }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getParentStudents = async (
  id: string,
  page: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${AUTH_GET_PARENT_ORGANISM_STUDENTS}/find?id=${id}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getSuggestedTeachers = async (
  page: string,
  userId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_GET_SUGGESTED_TEACHER}`, { page, userId }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAllTeachers = async (
  page: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${API_RESSOURCES}/advertisements/reserve/search`, { page }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getTeacher = async (
  page: any,
  search: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${API_RESSOURCES}/advertisements/reserve/search`, { page, search }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const sendBudgetDemand = async (
  id: string,
  idProf: string,
  idStud: string,
  montant: any,
  message: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_SEND_BUDGET}`, { id, idProf, idStud, montant, message }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const sendAccountTopUp = async (
  id: string,
  idStud: string,
  montant: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_SEND_ACCOUNT_TOP_UP}`, { id, idStud, montant }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const sendEqualTopUp = async (
  id: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_SEND_EQUAL_TOP_UP}`, { id }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const dissociateAccount = async (
  id: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_DISSOCIATE_ACCOUNT}`, { id }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getStudentHistoryData = async (
  id: string,
  page: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${AUTH_GET_STUDENT_HISTORY_DATA}/historique?idStud=${id}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getTeacherStudents = async (
  search: string,
  id: string,
  page: any,
  options?: { signal?: AbortSignal }   // 👈 allow optional signal
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");

    const response = await axios.get(
      `${AUTH_GET_TEACHER_STUDENTS}/all?search=${encodeURIComponent(search)}&id=${id}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
        signal: options?.signal, // 👈 pass signal to axios
      }
    );

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getTeacherAllStudents = async (
  profId: string,
  options?: { signal?: AbortSignal }
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");

    const response = await axios.get(
      `${API_RESSOURCES}/classes/get/all/students/${profId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
        signal: options?.signal, // 👈 pass signal to axios
      }
    );

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getOrganismClassAllStudents = async (
  organismId: string,
  options?: { signal?: AbortSignal }
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");

    const response = await axios.get(
      `${API_RESSOURCES}/classes/get/all/students/${organismId}?byOrganism=true`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
        signal: options?.signal, // 👈 pass signal to axios
      }
    );

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getTeacherStudentHistoryData = async (
  idStud: string,
  idProf: string,
  page: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${AUTH_GET_TEACHER_STUDENT_HISTORY_DATA}/historique?idStud=${idStud}&idProf=${idProf}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

/* export const rateStudent = async (
  id: string,
  rateCours: any,
  rateApplication: any,
  rateExercice: any,
  comment: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_RATE_STUDENTS}`, { id, rateCours, rateApplication, rateExercice, comment }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
}; */

export const rateStudent = async (
  id: string,
  rateCours: any,
  rateApplication: any,
  rateExercice: any,
  comment: any,
): Promise<ApiResponse | undefined> => {
  const MAX_RETRIES = 5;

  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  let attempt = 0;

  while (attempt < MAX_RETRIES) {
    try {
      const token = await getToken();
      if (!token) throw new Error("access token not valid");

      const response = await axios.post(`${AUTH_RATE_STUDENTS}`, { id, rateCours, rateApplication, rateExercice, comment }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error: any) {
      attempt++;

      const status = error?.response?.status;
      const retryableStatusCodes = [429, 500, 502, 503, 504];

      if (!retryableStatusCodes.includes(status) || attempt >= MAX_RETRIES) {
        throw error;
      }

      const delay = Math.pow(2, attempt) * 200;
      console.warn(`Retrying rateStudent (${attempt}/${MAX_RETRIES}) in ${delay}ms...`);
      await sleep(delay);
    }
  }
};

/* export const rateTeacher = async (
  id: string,
  explanationClarity: any,
  interactionsEngagement: any,
  relevanceOfApplications: any,
  comment: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_RATE_TEACHER}`, { id, explanationClarity, interactionsEngagement, relevanceOfApplications, comment }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
}; */

export const rateTeacher = async (
  id: string,
  explanationClarity: any,
  interactionsEngagement: any,
  relevanceOfApplications: any,
  comment: any,
): Promise<ApiResponse | undefined> => {
  const MAX_RETRIES = 5;

  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  let attempt = 0;

  while (attempt < MAX_RETRIES) {
    try {
      const token = await getToken();
      if (!token) throw new Error("access token not valid");

      const response = await axios.post(`${AUTH_RATE_TEACHER}`, { id, explanationClarity, interactionsEngagement, relevanceOfApplications, comment }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error: any) {
      attempt++;

      const status = error?.response?.status;
      const retryableStatusCodes = [429, 500, 502, 503, 504];

      if (!retryableStatusCodes.includes(status) || attempt >= MAX_RETRIES) {
        throw error;
      }

      const delay = Math.pow(2, attempt) * 200;
      console.warn(`Retrying rateTeacher (${attempt}/${MAX_RETRIES}) in ${delay}ms...`);
      await sleep(delay);
    }
  }
};

export const getStudentEmailPseudo = async (
  firstname: string,
  lastname: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_GET_STUDENTS_CREDENTIALS}`, { firstname, lastname }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const returnUserEmail = async (
  pseudo: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_GET_USER_EMAIL}`, { pseudo }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const cancelMeeting = async (
  idReservation: string,
  cancelMessage: string,
  user: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_CANCEL_MEETING}`, { idReservation, cancelMessage, user }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const cancelMeetingOrganism = async (
  collectiveReserveId: string,
  teacherId: string,
  reason: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.patch(`${process.env.REACT_APP_API_URL_RESSOURCES}/advertisements/collective/reserves/${collectiveReserveId}/cancel`, { teacherId, reason }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const sendScheduleMeetingMessage = async (
  studentId: string,
  reservationId: string,
  reason: string,
): Promise<any | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_SEND_SCHEDULE_MESSAGE}`, { studentId, reservationId, reason }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.status;
  } catch (error: any) {
    throw error;
  }
};

export const checkScheduleMeeting = async (
  studentId: string,
  reservationId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_CHECK_SCHEDULE_STUDENT}`, { studentId, reservationId }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const checkCancelMeeting = async (
  userId: string,
  reservationId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_CHECK_CANCEL}`, { userId, reservationId }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const scheduleMeeting = async (
  data: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_SCHEDULE_MEETING}`, { idReservation: data?.idReservation, newDate: data?.newDate, newRange: data?.newRange, newPrice: data?.newPrice, newCredit: data?.newCredit, motif: data?.motif }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const scheduleMeetingOrganism = async (
  data: any,
  collectiveReservationId: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.patch(`${process.env.REACT_APP_API_URL_RESSOURCES}/advertisements/collective/reserves/${collectiveReservationId}/replan`, { teacherId: data?.teacherId, newStartDate: data?.newStartDate, newRange: data?.newRange, newDay: data?.newDay, reason: data?.reason, newPrice: data?.newPrice, byCredits: data?.byCredits }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const dissociateStudent = async (
  managerId: string,
  idStudent: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${AUTH_DISSOCIATE_STUDENT}`, { managerId, idStudent }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const CheckAffiliationToken = async (
  emailToken: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/affiliations/accept-request?token=${emailToken}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const deleteAccount = async (
  userId: string
): Promise<ApiResponse | undefined> => {
  try {
    const response = await axios.delete(
      `${API_RESSOURCES}/users/${userId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const inviteStudentsToCourse = async (
  classeId: string,
  creneauId: string,
  students: any,
  teacherId: string
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${API_RESSOURCES}/advertisements/open-class/session/invite`, { classeId, creneauId, students, teacherId }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const inviteStudentsToClassroom = async (
  classeId: string,
  studentId: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${API_RESSOURCES}/classes/collective/class/requestStudentToJoinClass`, { classeId, studentId }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error: any) {
    throw error;
  }
};
